import { render, staticRenderFns } from "./CheckoutSubmitOrder.vue?vue&type=template&id=073df697&scoped=true"
import script from "./CheckoutSubmitOrder.vue?vue&type=script&lang=js"
export * from "./CheckoutSubmitOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073df697",
  null
  
)

export default component.exports